const spdata_2024 = [
  {
    Roll: "19BEC066",
    Name: "Manan jayant bhimani",
    Company: "Arvasit technolabs pvt. ltd.",
    Personal: "mananbhimani7@gmail.com",
    Linkedin: "https://www.linkedin.com/in/manan-bhimani-2598ba217",
  },
  {
    Roll: "19BEC068",
    Name: "Manav chokshi",
    Company: "E-infochips",
    Personal: "manavchok@gmail.com",
    Linkedin: "https://www.linkedin.com/in/manav-chokshi-6b6273168/",
  },
  {
    Roll: "19BEC125",
    Name: "Shivam rajesh mirani",
    Company: "Levant solar pvt. ltd.",
    Personal: "yashmrn@gmail.com",
    Linkedin: "-",
  },
  {
    Roll: "20BEC001",
    Name: "Aaditya vivek darakh ",
    Company: "IIM Ahmedabad",
    Personal: "Aaditya.darakh@gmail.com",
    Linkedin: "www.linkedin.com/in/aaditya-darakh-b0b0bb276",
  },
  {
    Roll: "20BEC002",
    Name: "Adarsh ajit tiwary",
    Company: "E-infochips",
    Personal: "adarshtiwa07@gmail.com",
    Linkedin: "https://www.linkedin.com/in/adarsh-tiwari-956b1a239",
  },
  {
    Roll: "20BEC003",
    Name: "Aditya agrawal",
    Company: "E-infochips",
    Personal: "agrawaladitya02@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aditya-agrawal-5ba334218/",
  },
  {
    Roll: "20BEC004",
    Name: "Aditya jha",
    Company: "E-infochips",
    Personal: "jhaaditya2684@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aditya-jha-960026210",
  },
  {
    Roll: "20BEC005",
    Name: "Aditya jha",
    Company: "Vasoya brothers infotech",
    Personal: "adijha2905@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aditya-jha-727029204/",
  },
  {
    Roll: "20BEC006",
    Name: "Aditya kalpak shah",
    Company: "Ey-ernst and young",
    Personal: "adityashah1603@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aditya-shah-b51754235/",
  },
  {
    Roll: "20BEC007",
    Name: "Akashkumar kishorbhai tailor",
    Company: "E-infochips",
    Personal: "tailorakash2320@gmail.com",
    Linkedin: "https://www.linkedin.com/in/akash-tailor/",
  },
  {
    Roll: "20BEC008",
    Name: "Aman yogesh kashyap",
    Company: "Protekg power electronics pvt ltd",
    Personal: "amankashyap180502@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aman-yogesh-204510280",
  },
  {
    Roll: "20BEC009",
    Name: "Anshul kaushal dani ",
    Company: "VBC hydraulics",
    Personal: "anshuldani@gmail.com",
    Linkedin: "https://www.linkedin.com/in/anshul-dani/",
  },
  {
    Roll: "20BEC010",
    Name: "Anushka ravinder bist",
    Company: "Nayara energy",
    Personal: "anushkabist2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/anushka-bist-7583611a7",
  },
  {
    Roll: "20BEC011",
    Name: "Arnav sharma",
    Company: "Deepcept ai pvt. ltd.",
    Personal: "arnavcsharma@gmail.com",
    Linkedin: "https://www.linkedin.com/in/arnav-sharma-4b9137255/",
  },
  {
    Roll: "20BEC012",
    Name: "Aryan chetankumar lakdawala",
    Company: "E-infochips",
    Personal: "aryanlakdawala22@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aryan-lakdawala-9324b526a/",
  },
  {
    Roll: "20BEC013",
    Name: "Aryan anuj desai",
    Company: "E-infochips",
    Personal: "aryandesai001@gmail.com",
    Linkedin: "https://www.linkedin.com/in/aryan-desai-124409229/",
  },
  {
    Roll: "20BEC014",
    Name: "Ayush deb",
    Company: "Hyperlab, studiocarbon",
    Personal: "debayush2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ayush-deb-44aa3a212/",
  },
  {
    Roll: "20BEC015",
    Name: "Ayush lalitbhai shah",
    Company: "Adani enterprise",
    Personal: "ayushshah598@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ayush-shah-l01",
  },
  {
    Roll: "20BEC016",
    Name: "Devangkumar dhirajlal bathwar ",
    Company: "Wind world ind ltd",
    Personal: "20bec016@nirmauni.ac.in",
    Linkedin: "linkedin.com/in/devang-bathwar-218a4a1bb",
  },
  {
    Roll: "20BEC017",
    Name: "Bhavya prasant desai",
    Company: "In-house",
    Personal: "bhavya.p.desai2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/bhavyapdesai/",
  },
  {
    Roll: "20BEC018",
    Name: "Bhavya ashwinbhai patel",
    Company: "E-infochips",
    Personal: "bhavyapatel121002@gmail.com ",
    Linkedin: "http://www.linkedin.com/in/bhavya-patel-270481228",
  },
  {
    Roll: "20BEC019",
    Name: "Vardan krishna chetnani",
    Company: "In-house",
    Personal: "vardanchetnani7@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vardan-chetnani-1516b2202",
  },
  {
    Roll: "20BEC020",
    Name: "Vivek chandreshkumar dedani",
    Company: "Hyperlab, studiocarbon",
    Personal: "vivek.dedani2003@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vivek-dedani-9b07b5203/",
  },
  {
    Roll: "20BEC021",
    Name: "Dev pavankumar parikh",
    Company: "In-house",
    Personal: "devparikh@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dev-parikh-8179b8278/",
  },
  {
    Roll: "20BEC022",
    Name: "Devang javiya rajeshbhai",
    Company: "E-infochips",
    Personal: "devrjaviya@gmail.com",
    Linkedin: "https://www.linkedin.com/in/devang-javia-77572b203/",
  },
  {
    Roll: "20BEC023",
    Name: "Devesh pareek",
    Company: "E-infochips",
    Personal: "pareekdevesh6230@gmail.com",
    Linkedin: "linkedin.com/in/devesh-pareek-6587a31ba",
  },
  {
    Roll: "20BEC024",
    Name: "Dhruv Harsukhbhai Dholariya ",
    Company: "Northern Trust",
    Personal: "dhruvdholariya44255@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhruv-dholariya-814aaa201/",
  },
  {
    Roll: "20BEC025",
    Name: "Dhruvi kamalkumar thakar",
    Company: "E-infochips",
    Personal: "dhruvikthakar9112@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhruvi-thakar-ba5b21220/",
  },
  {
    Roll: "20BEC026",
    Name: "Dhruvi nilambhai patel",
    Company: "Protocol zone pvt.ltd",
    Personal: "pateldhruvi2503@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhruvi-patel-b3aa1a212/ ",
  },
  {
    Roll: "20BEC027",
    Name: "Dhyan umeshkumar thakkar",
    Company: "In-house",
    Personal: "th.dhyan@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhyanthakkar/",
  },
  {
    Roll: "20BEC028",
    Name: "Dhyanik bhavesh pujara",
    Company: "Ocean abrasive",
    Personal: "pujaradhyanik@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhyanikp/",
  },
  {
    Roll: "20BEC029",
    Name: "Dhyey ketan mehta",
    Company: "E-infochips",
    Personal: "dhyeymehta619@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhyey-mehta-607048230",
  },
  {
    Roll: "20BEC030",
    Name: "Dishank yogesh garg",
    Company: "E-infochips",
    Personal: "dishankgarg03@gmail.com",
    Linkedin: "linkedin.com/in/dishank-garg",
  },
  {
    Roll: "20BEC031",
    Name: "Divyesh apurva gandhi",
    Company: "E-infochips",
    Personal: "divyeshgandhi2003@gmail.com",
    Linkedin: "https://www.linkedin.com/in/divyesh-gandhi-1a6385218/",
  },
  {
    Roll: "20BEC033",
    Name: "Dixitkumar rasikbhai dudhat ",
    Company: "Finvant research capital llp",
    Personal: "dixitdudhat33@gmail.com",
    Linkedin: "https://www.linkedin.com/mwlite/in/dixit-dudhat-013282205",
  },
  {
    Roll: "20BEC034",
    Name: "Shubh dharmesh gajjar",
    Company: "Oizom",
    Personal: "shubhgajjar2704@gmail.com",
    Linkedin: "https://www.linkedin.com/in/shubh-gajjar-b744261ba",
  },
  {
    Roll: "20BEC035",
    Name: "Vatsal prakashchandra gajjar",
    Company: "E-infochips",
    Personal: "vatsalpgajjar@gmail.com",
    Linkedin: "https://in.linkedin.com/in/vatsal-gajjar-a689b3267",
  },
  {
    Roll: "20BEC036",
    Name: "Hiten bharatkumar galiya",
    Company: "E-infochips",
    Personal: "hitengaliya15@gmail.com",
    Linkedin: "www.linkedin.com/in/ hiten-galiya-553bb520b",
  },
  {
    Roll: "20BEC037",
    Name: "Gaurav nandkishore bablani",
    Company: "E-infochips",
    Personal: "gauravzoom2022@gmail.com",
    Linkedin: "http://linkedin.com/in/gaurav-bablani-793655265",
  },
  {
    Roll: "20BEC038",
    Name: "Riya ashish gautam",
    Company: "S.p. industries",
    Personal: "riyagautam5599@gmail.com",
    Linkedin: "http://www.linkedin.com/in/riya-gautam-065303210",
  },
  {
    Roll: "20BEC039",
    Name: "Harsh hiteshbhai chotaliya",
    Company: "In-house",
    Personal: "harshchotaliya7@gmail.com",
    Linkedin: "linkedin.com/in/harshchotaliya",
  },
  {
    Roll: "20BEC040",
    Name: "Harshvardhan sharma",
    Company: "Creart solutions",
    Personal: "hs883532@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsh-sharma-37b624263/",
  },
  {
    Roll: "20BEC041",
    Name: "Henil prakashbhai patel ",
    Company: "Cibos",
    Personal: "hpyes44@gmail.com",
    Linkedin: "https://www.linkedin.com/in/henil-patel-58511520b",
  },
  {
    Roll: "20BEC042",
    Name: "Hrishit gajjar",
    Company: "E-infochips",
    Personal: "hrishit.gajjar10@gmail.com",
    Linkedin: "https://www.linkedin.com/in/hrishit-gajjar-063676223",
  },
  {
    Roll: "20BEC043",
    Name: "Jainam padam jain",
    Company: "Agarwal engineering",
    Personal: "jainamjain97251@gmail.com",
    Linkedin: "www.linkedin.com/in/jainamjainofficial",
  },
  {
    Roll: "20BEC044",
    Name: "Janesh choudhary ",
    Company: "E-infochips",
    Personal: "janesh1162@gmail.com",
    Linkedin: "https://www.linkedin.com/in/cjanesh",
  },
  {
    Roll: "20BEC045",
    Name: "Jay manojkumar patel",
    Company: "In-house",
    Personal: "jay942961@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jay-patel-64032423a/",
  },
  {
    Roll: "20BEC046",
    Name: "Jenil mahesh gandhi",
    Company: "Tirth agro technology pvt. ltd.",
    Personal: "jenilmgandhi321@gmail.com",
    Linkedin: "www.linkedin.com/in/jenilmgandhi",
  },
  {
    Roll: "20BEC048",
    Name: "Jugal bipin upadhyay",
    Company: "VBC hydraulics",
    Personal: "jugalbipinupadhyay@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jugal-upadhyay-b66326275/",
  },
  {
    Roll: "20BEC050",
    Name: "Nilkanth vipulkumar kapadia",
    Company: "E-infochips",
    Personal: "nilkanthkapadia5@gmail.com",
    Linkedin: "www.linkedin.com/in/nilkanth-kapadia-96b651207",
  },
  {
    Roll: "20BEC051",
    Name: "Karan singh choudhary",
    Company: "E-infochips",
    Personal: "iamkaran2218@gmail.com",
    Linkedin: "https://www.linkedin.com/in/karan-choudhary-2337b91ba",
  },
  {
    Roll: "20BEC052",
    Name: "Karan pinal shah",
    Company: "In-house",
    Personal: "shahk3095@gmail.com",
    Linkedin: "https://www.linkedin.com/in/karan-s-6201001b9/",
  },
  {
    Roll: "20BEC053",
    Name: "Kashyap sindhav ",
    Company: "In-house",
    Personal: "kashyapsindhav682@gmail.com",
    Linkedin: "https://www.linkedin.com/in/kashyap-sindhav-146a26212",
  },
  {
    Roll: "20BEC054",
    Name: "Kathan jain",
    Company: "E-infochips",
    Personal: "kathanjain9@gmail.com",
    Linkedin: "www.linkedin.com/in/kathanjain9",
  },
  {
    Roll: "20BEC055",
    Name: "Kathiya pruthvirajsinh anopsinh",
    Company: "In-house",
    Personal: "pruthvirajsinhkathiya123@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pruthvirajsinhkathiya/",
  },
  {
    Roll: "20BEC056",
    Name: "Darshi khalasi",
    Company: "In-house",
    Personal: "khalasidarshi@gmail.com",
    Linkedin: "https://www.linkedin.com/in/darshi-khalasi-93067522b/",
  },
  {
    Roll: "20BEC057",
    Name: "Kinjal d ahuja",
    Company: "Vegg (an iot company)",
    Personal: "kinjalda3175@gmail.com ",
    Linkedin: "https://www.linkedin.com/in/kinjal-ahuja-36072a144",
  },
  {
    Roll: "20BEC058",
    Name: "Kushagra baser",
    Company: "E-infochips",
    Personal: "kush95212@gmail.com",
    Linkedin: "https://www.linkedin.com/in/kushagra-baser-3735861ba",
  },
  {
    Roll: "20BEC059",
    Name: "Lavanya paritosh joshi",
    Company: "E-infochips",
    Personal: "lavanyajoshi11357@gmail.com ",
    Linkedin: "https://www.linkedin.com/in/lavanya-joshi-6676341b9/",
  },
  {
    Roll: "20BEC060",
    Name: "Maanak brijesh gadia",
    Company: "E-infochips",
    Personal: "maanakgadia@gmail.com",
    Linkedin: "https://www.linkedin.com/in/maanak-gadia-8545b4216/",
  },
  {
    Roll: "20BEC061",
    Name: "Maharshi dharmesh patel ",
    Company: "Physical research laboratory (PRL)",
    Personal: "mdpatel1905@gmail.com",
    Linkedin: "https://www.linkedin.com/in/maharshi-patel-192305mdp",
  },
  {
    Roll: "20BEC062",
    Name: "Zeel manojbhai makadia",
    Company: "E-infochips",
    Personal: "zeelmakadia5@gmail.com",
    Linkedin: "https://www.linkedin.com/in/zeel-makadia-018749222",
  },
  {
    Roll: "20BEC065",
    Name: "Maurya nirav shah",
    Company: "Innodel technologies pvt. ltd.",
    Personal: "mauryashah13@gmail.com",
    Linkedin: "https://www.linkedin.com/in/maurya-shah-a25522220",
  },
  {
    Roll: "20BEC066",
    Name: "Mayur das",
    Company: "E-infochips",
    Personal: "mayurdas2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mayur-das-475748243/",
  },
  {
    Roll: "20BEC067",
    Name: "Meet hitesh sorathia",
    Company: "E-infochips",
    Personal: "sorathiameet19@gmail.com",
    Linkedin: "https://www.linkedin.com/in/meet-sorathia-090674177",
  },
  {
    Roll: "20BEC068",
    Name: "Vishwa nitin mevawala",
    Company: "E-infochips",
    Personal: "vishwamevawala@gmail.com",
    Linkedin: "http://www.linkedin.com/in/vishwa-mevawala-5b186020b",
  },
  {
    Roll: "20BEC069",
    Name: "Yash nileshbhai mevawala",
    Company: "E-infochips",
    Personal: "yashmevawala9953@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mevawala-yash-756641280",
  },
  {
    Roll: "20BEC070",
    Name: "Keval ganeshbhai mistry",
    Company: "In-house",
    Personal: "kevalmistry7733@gmail.com",
    Linkedin: "www.linkedin.com/in/ kevalmistry1601",
  },
  {
    Roll: "20BEC071",
    Name: "Mrudani vishal hada",
    Company: "E-infochips",
    Personal: "mrudanihada@gmail.com ",
    Linkedin: "https://www.linkedin.com/in/mrudani-hada-36201b218",
  },
  {
    Roll: "20BEC072",
    Name: "Mukta hemang shah",
    Company: "Cygnet infotech pvt. ltd.",
    Personal: "muktashah88@gmail.com",
    Linkedin: "https://www.linkedin.com/in/mukta-shah-6354a6218/",
  },
  {
    Roll: "20BEC073",
    Name: "Munmun sangtani",
    Company: "Agarwal engineering",
    Personal: "munmunsangtani@gmail.com",
    Linkedin: 'https://www.linkedin.com/in/munmun-sangtani-4784a728b/',
  },
  {
    Roll: "20BEC074",
    Name: "Namra divyakumar shah",
    Company: "Amazon",
    Personal: "namra9720@gmail.com",
    Linkedin: "https://www.linkedin.com/in/shahnamra11/",
  },
  {
    Roll: "20BEC075",
    Name: "Raj vijaykumar nirmal",
    Company: "E-infochips",
    Personal: "rajnirmal2604@gmail.com",
    Linkedin: "https://www.linkedin.com/in/raj-nirmal2604",
  },
  {
    Roll: "20BEC076",
    Name: "Palak kapuriya",
    Company: "Hyperlab, studiocarbon",
    Personal: "palak.kapuriya912@gmail.com",
    Linkedin: "linkedin.com/in/palak-kapuriya",
  },
  {
    Roll: "20BEC077",
    Name: "Palak jignesh naik",
    Company: "Schneider electric",
    Personal: "palaknaik4@gmail.com",
    Linkedin: "https://www.linkedin.com/in/palak-naik-1281ba210/",
  },
  {
    Roll: "20BEC079",
    Name: "Ayush asit parekh ",
    Company: "Nivida web solutions pvt ltd",
    Personal: "ayush.parekh1007@gmail.com",
    Linkedin:
      "https://www.linkedin.com/in/ayushparekh18?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BJ2leyXYcQQaO4OFJmXInBg%3D%3D",
  },
  {
    Roll: "20BEC080",
    Name: "Parth mayur jariwala",
    Company: "Maitri diamonds",
    Personal: "parthparth4545@gmail.com",
    Linkedin: "https://www.linkedin.com /in/parth-jariwala-b88784206",
  },
  {
    Roll: "20BEC081",
    Name: "Parth parikh",
    Company: "E-infochips",
    Personal: "parthparikh2911@hotmail.com",
    Linkedin: "https://www.linkedin.com/in/parth-parikh-078965210",
  },
  {
    Roll: "20BEC082",
    Name: "Parth dharmendra shah",
    Company: "Nivida web solutions pvt ltd",
    Personal: "parthshahofficial09@gmail.com",
    Linkedin: "https://www.linkedin.com/in/parth-shah-66a556203/",
  },
  {
    Roll: "20BEC083",
    Name: "Brijesh ravindrakumar patel",
    Company: "E-infochips",
    Personal: "bri.patel3011@gmail.com",
    Linkedin: "https://www.linkedin.com/in/brijesh-patel-4b5656212/",
  },
  {
    Roll: "20BEC084",
    Name: "Harsh vijaykumar patel",
    Company: "E-infochips",
    Personal: "harshpatel150203@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harsh-patel-b700b4215",
  },
  {
    Roll: "20BEC085",
    Name: "Maitri sachinbhai patel",
    Company: "E-infochips",
    Personal: "maitripatel0410@gmail.com",
    Linkedin: "https:/linkedin.com/in/maitri-patel-2a46471ba",
  },
  {
    Roll: "20BEC086",
    Name: "Parth narendrabhai patel",
    Company: "E-infochips",
    Personal: "patelparthn44@gmail.com",
    Linkedin: "https://www.linkedin.com/in/parthpatel2010",
  },
  {
    Roll: "20BEC087",
    Name: "Tapan chandrakant patel",
    Company: "Cibos",
    Personal: "ptapan2707@gmail.com",
    Linkedin: "www.linkedin.com/in/ tapan-patel-609842201",
  },
  {
    Roll: "20BEC088",
    Name: "Pawan lakhani",
    Company: "E-infochips",
    Personal: "pawandlakhani@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pawanlakhani",
  },
  {
    Roll: "20BEC089",
    Name: "Devika srinivasarao pedada",
    Company: "E-infochips",
    Personal: "devikaspedada@gmail.com",
    Linkedin: "https://www.linkedin.com/in/devika-pedada",
  },
  {
    Roll: "20BEC090",
    Name: "Pinkal bhikhabhai makwana",
    Company: "Cibos",
    Personal: "pratikmakwana009@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pratik-makwana-501818214",
  },
  {
    Roll: "20BEC093",
    Name: "Dhruv bhupendrabhai prajapati",
    Company: "E-infochips",
    Personal: "dhruv2372002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/dhruv-prajapati-a0039b1b7",
  },
  {
    Roll: "20BEC094",
    Name: "Prajay hitesh kotecha",
    Company: "Isro",
    Personal: "prajayhkotecha@gmail.com",
    Linkedin: "https://www.linkedin.com/in/prajay-kotecha-03a5b3238/",
  },
  {
    Roll: "20BEC095",
    Name: "Pranjal prakash yadav",
    Company: "Knowledgeops software solutions pvt. ltd.",
    Personal: "Pranjalyadav.yp@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pranjalyadav30/",
  },
  {
    Roll: "20BEC096",
    Name: "Pranshu bansal",
    Company: "E-infochips",
    Personal: "pranshubansal8890@gmail.com",
    Linkedin: "https://www.linkedin.com/in/pranshu-bansal-998025203/",
  },
  {
    Roll: "20BEC098",
    Name: "Prathmesh manoj borse",
    Company: "E-infochips",
    Personal: "prathmeshb1164@gmail.com",
    Linkedin: "https://www.linkedin.com/in/prathmesh-borse1/",
  },
  {
    Roll: "20BEC099",
    Name: "Akshaj rai",
    Company: "In-house",
    Personal: "akshajrai101@gmail.com",
    Linkedin: "https://www.linkedin.com/in/akshaj-rai-ba8818270",
  },
  {
    Roll: "20BEC100",
    Name: "Deep mukeshbhai ramoliya ",
    Company: "Creart solutions",
    Personal: "ramoliyadee55@gmail.com",
    Linkedin: "https://www.linkedin.com/in/deep-ramoliya-32b852203",
  },
  {
    Roll: "20BEC101",
    Name: "Harinee hitesh rathod",
    Company: "E-infochips",
    Personal: "harineerathod@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harinee-rathod-26448925a/",
  },
  {
    Roll: "20BEC102",
    Name: "Riththika sukanandan",
    Company: "E-infochips",
    Personal: "riththikasukanandan@gmail.com",
    Linkedin: "www.linkedin.com/in/riththika-s-629aa91ba/",
  },
  {
    Roll: "20BEC103",
    Name: "Rohan sandeep desai ",
    Company: "A and r code hub llb",
    Personal: "desairohan1501@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rohan-desai-2b5825220",
  },
  {
    Roll: "20BEC104",
    Name: "Rohan jignesh sarvaiya",
    Company: "Svnit",
    Personal: "rjsbme101@gmail.com",
    Linkedin: "https://www.linkedin.com/in/rohan-sarvaiya-55667822b",
  },
  {
    Roll: "20BEC105",
    Name: "Ruchi anil lohiya",
    Company: "E-infochips",
    Personal: "lohiyaruchi30@gmail.com",
    Linkedin: "https://www.linkedin.com/in/ruchi-lohiya-3b7469206/",
  },
  {
    Roll: "20BEC106",
    Name: "Sahaj devang soni",
    Company: "R wadiwala securities pvt. ltd",
    Personal: "sahaj.dsoni@gmail.com",
    Linkedin: "https://www.linkedin.com/in/sahaj-d-soni/",
  },
  {
    Roll: "20BEC107",
    Name: "Salonee aggarwal",
    Company: "Tally solutions pvt ltd",
    Personal: "saloneeaggarwal4444@gmail.com",
    Linkedin: "https://www.linkedin.com/in/salonee-aggarwal-605015210/",
  },
  {
    Roll: "20BEC108",
    Name: "Sanchit jitendra sharma",
    Company: "E-infochips",
    Personal: " sanchitjsharma2603@gmail.com",
    Linkedin: "https://www.linkedin.com/in/sanchit-sharma-39478520a",
  },
  {
    Roll: "20BEC110",
    Name: "Amee amar shah",
    Company: "Institute for plasma research",
    Personal: "shahamee00056@gmail.com",
    Linkedin:
      "https://www.linkedin.com/in/amee-shah-7b9519279?lipi=urn%3Ali%3Apage%3Ad_flagship3_profile_view_base_contact_details%3BUdX2%2FzCrQU%2Bym0mg5qZoFA%3D%3D",
  },
  {
    Roll: "20BEC111",
    Name: "Harshesh manish shah",
    Company: "E-infochips",
    Personal: "harshesh9802@gmail.com",
    Linkedin: "https://www.linkedin.com/in/harshesh-shah-00b7001b8/",
  },
  {
    Roll: "20BEC112",
    Name: "Nitanshu rupen shah",
    Company: "E-infochips",
    Personal: "nitanshu1219@gmail.com",
    Linkedin: "https://www.linkedin.com/in/nitanshu-shah-909411218",
  },
  {
    Roll: "20BEC113",
    Name: "Vaishnavi shah",
    Company: "E-infochips",
    Personal: "vpshah1912@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vaishnavi-shah-60a48b203/",
  },
  {
    Roll: "20BEC114",
    Name: "Sakshi govind shamnani",
    Company: "Tally solutions pvt ltd",
    Personal: "shamnanisakshi2009@gmail.com",
    Linkedin: "https://in.linkedin.com/in/sakshi-shamnani-24b17b238",
  },
  {
    Roll: "20BEC115",
    Name: "Krisha dinesh sheth",
    Company: "E-infochips",
    Personal: "krishasheth2@gmail.com",
    Linkedin: "https://www.linkedin.com/in/krisha-sheth-b3b967211/",
  },
  {
    Roll: "20BEC116",
    Name: "Shruti kumari shrivastava",
    Company: "E-infochips",
    Personal: "shrutishrivastava22ss@gmail.com",
    Linkedin: "www.linkedin.com/in/shrutikshrivastava",
  },
  {
    Roll: "20BEC118",
    Name: "Siddhant shirish srivastava",
    Company: "Amazon",
    Personal: "siddhantcbse@gmail.com",
    Linkedin: "https://www.linkedin.com/in/siddhant-srivastava-7a8322210",
  },
  {
    Roll: "20BEC119",
    Name: "Siddharth agarwal",
    Company: "Deepcept ai pvt. ltd.",
    Personal: "siddharthagarwal543@gmail.com",
    Linkedin: "https://www.linkedin.com/in/siddharth-agarwal-a6b50b12a/",
  },
  {
    Roll: "20BEC120",
    Name: "Sneha mukesh jain",
    Company: "E-infochips",
    Personal: "jainsneha2909@gmail.com",
    Linkedin: "https://www.linkedin.com/in/sneha-jain-29b177201/",
  },
  {
    Roll: "20BEC122",
    Name: "Sagar h sorathiya",
    Company: "E-infochips",
    Personal: "Sorathiyasagar208@gmail.com",
    Linkedin: "https://www.linkedin.com/in/sagar-sorathiya-714a8b209",
  },
  {
    Roll: "20BEC124",
    Name: "Suraj omprakash modi",
    Company: "E-infochips",
    Personal: "modisuraj1007@gmail.com",
    Linkedin: "https://www.linkedin.com/in/suraj-modi-8a744b12b/",
  },
  {
    Roll: "20BEC125",
    Name: "Tanisha dhingra",
    Company: "Digitronics",
    Personal: "tanisha16dhingra@gmail.com",
    Linkedin: "www.linkedin.com/in/tanisha-dhingra-b9a128280",
  },
  {
    Roll: "20BEC126",
    Name: "Tanisha kanungo",
    Company: "In-house",
    Personal: "tanishakanungo31@gmail.com",
    Linkedin: "https://www.linkedin.com/in/tanisha-kanungo-a83143220/",
  },
  {
    Roll: "20BEC127",
    Name: "Tanvi dhoka",
    Company: "E-infochips",
    Personal: "tanvidhoka2002@gmail.com",
    Linkedin: "https://www.linkedin.com/in/tanvi-dhoka-5889a2200/",
  },
  {
    Roll: "20BEC128",
    Name: "Niharika meghnad thakar",
    Company: "Optimized solutions limited",
    Personal: "niharikathakar.02@gmail.com",
    Linkedin: "https://www.linkedin.com/in/niharika-thakar-04b481219/",
  },
  {
    Roll: "20BEC129",
    Name: "Masum gautambhai thakkar",
    Company: "E-infochips",
    Personal: "masumthakkar2803@gmail.com",
    Linkedin: "www.linkedin.com/in/masum-thakkar-06126a259",
  },
  {
    Roll: "20BEC130",
    Name: "Arya umashankar tripathi",
    Company: "E-infochips",
    Personal: "aryatripathi195@gmail.com",
    Linkedin: "https://www.linkedin.com/in/arya-tripathi-910493218/",
  },
  {
    Roll: "20BEC131",
    Name: "Trushti gopal selarka",
    Company: "E-infochips",
    Personal: "trushtiselarka@gmail.com",
    Linkedin: "https://www.linkedin.com/in/trushti-s-540582132",
  },
  {
    Roll: "20BEC132",
    Name: "Umang alpeshkumar parmar",
    Company: "Aligntogether",
    Personal: "1412003umamg@gmail.com",
    Linkedin: "https://www.linkedin.com/in/umang-parmar-354691203/",
  },
  {
    Roll: "20BEC133",
    Name: "Urvashi krishna kumar mundra",
    Company: "Tally solutions pvt ltd",
    Personal: "mundraurvashi@gmail.com",
    Linkedin: "https://www.linkedin.com/in/urvashimundra",
  },
  {
    Roll: "20BEC134",
    Name: "Vedant suresh patel",
    Company: "Xinje electric pvt.ltd",
    Personal: "vedant080602@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vedant-patel-771274203",
  },
  {
    Roll: "20BEC135",
    Name: "Yash talshibhai viradiya ",
    Company: "E-infochips",
    Personal: "yashviradiya2065@gmail.com",
    Linkedin: "https://www.linkedin.com/in/yash-viradiya-52994820a",
  },
  {
    Roll: "20BEC136",
    Name: "Vrushti mukesh modi",
    Company: "Oizom",
    Personal: "vrumodi3600@gmail.com",
    Linkedin: "https://www.linkedin.com/in/vrushti-modi-a557b5200/",
  },
  {
    Roll: "20BEC137",
    Name: "Yash devanand purohit",
    Company: "E-infochips",
    Personal: "purohityash13@gmail.com",
    Linkedin: "linkedin.com/in/yash-purohit-96a9431b9",
  },
  {
    Roll: "21BEC502",
    Name: "Nishid vijay kadam",
    Company: "Matric comsec pvt. ltd",
    Personal: "Nishidvk0206@gmail.com",
    Linkedin: "https://www.linkedin.com/in/nishid-kadam-78a12b24a",
  },
  {
    Roll: "21BEC503",
    Name: "Raj katariya",
    Company: "Singularityaix",
    Personal: "ahirraj789@gmail.com",
    Linkedin: "https://www.linkedin.com/in/raj-katariya-5b827b252",
  },
  {
    Roll: "21BEC505",
    Name: "Jaykumar umeshbhai patel",
    Company: "E-infochips",
    Personal: "jup3109@gmail.com",
    Linkedin: "https://www.linkedin.com/in/jay-patel-83478326a",
  },
  {
    Roll: "21BEC507",
    Name: "Aayush parenbhai shah",
    Company: "Alteem instruments",
    Personal: "aayushshah27620@gmail.com",
    Linkedin: "linkedin.com/in/aayush-shah-27620aas",
  },
  {
    Roll: "21BEC508",
    Name: "Saman iqbal ahmed shaikh",
    Company: "In-house",
    Personal: "samanshaikh212@gmail.com",
    Linkedin: "https://www.linkedin.com/in/saman-shaikh-7329751a9",
  },
];

export default spdata_2024;
